export const COUNTRY_CODES: string[] = [
  "1",
  "1242",
  "1246",
  "1264",
  "1268",
  "1284",
  "1340",
  "1345",
  "1441",
  "1473",
  "1649",
  "1664",
  "1670",
  "90392",
  "1671",
  "1684",
  "1721",
  "1758",
  "1767",
  "1784",
  "1787",
  "1939",
  "1808",
  "1809",
  "1829",
  "1849",
  "1868",
  "1869",
  "1876",
  "20",
  "211",
  "212",
  "213",
  "216",
  "218",
  "220",
  "221",
  "222",
  "223",
  "224",
  "225",
  "226",
  "227",
  "228",
  "229",
  "230",
  "231",
  "232",
  "233",
  "234",
  "235",
  "236",
  "237",
  "238",
  "239",
  "240",
  "241",
  "242",
  "243",
  "244",
  "245",
  "246",
  "247",
  "248",
  "249",
  "250",
  "251",
  "252",
  "253",
  "254",
  "255",
  "888",
  "25524",
  "256",
  "257",
  "258",
  "260",
  "261",
  "262",
  "262269",
  "262639",
  "263",
  "264",
  "265",
  "266",
  "267",
  "268",
  "269",
  "27",
  "290",
  "2908",
  "291",
  "297",
  "298",
  "299",
  "30",
  "31",
  "32",
  "33",
  "34",
  "350",
  "351",
  "352",
  "353",
  "354",
  "355",
  "356",
  "357",
  "358",
  "35818",
  "359",
  "36",
  "370",
  "371",
  "372",
  "373",
  "3732",
  "3735",
  "374",
  "37447",
  "37497",
  "375",
  "376",
  "377",
  "378",
  "380",
  "381",
  "382",
  "383",
  "385",
  "386",
  "387",
  "389",
  "39",
  "3906698",
  "379",
  "40",
  "41",
  "420",
  "421",
  "423",
  "43",
  "44",
  "441481",
  "447781",
  "447839",
  "447911",
  "441534",
  "441624",
  "447524",
  "447624",
  "447924",
  "4428",
  "45",
  "46",
  "47",
  "4779",
  "48",
  "49",
  "500",
  "501",
  "502",
  "503",
  "504",
  "505",
  "506",
  "507",
  "508",
  "509",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "590",
  "591",
  "592",
  "593",
  "594",
  "595",
  "596",
  "597",
  "598",
  "5993",
  "5997",
  "5994",
  "5999",
  "60",
  "61",
  "6189162",
  "6189164",
  "62",
  "63",
  "64",
  "65",
  "66",
  "670",
  "672",
  "6721",
  "6723",
  "673",
  "674",
  "675",
  "676",
  "677",
  "678",
  "679",
  "680",
  "681",
  "682",
  "683",
  "685",
  "686",
  "687",
  "688",
  "689",
  "690",
  "691",
  "692",
  "7",
  "76",
  "77",
  "800",
  "808",
  "81",
  "82",
  "84",
  "850",
  "852",
  "853",
  "855",
  "856",
  "86",
  "870",
  "878",
  "880",
  "881",
  "8810",
  "8811",
  "8812",
  "8813",
  "8816",
  "8817",
  "8818",
  "8819",
  "882",
  "883",
  "88213",
  "88216",
  "886",
  "90",
  "91",
  "92",
  "93",
  "94",
  "95",
  "960",
  "961",
  "962",
  "963",
  "964",
  "965",
  "966",
  "967",
  "968",
  "970",
  "971",
  "972",
  "973",
  "974",
  "975",
  "976",
  "977",
  "979",
  "98",
  "992",
  "993",
  "994",
  "995",
  "99534",
  "996",
  "998",
];
